import React from "react";
import { Navigate } from "react-router-dom";

//! COMMON
// Unauthorized
const Unauthorized = React.lazy(() => import("pages/Unauthorized"));

// Dashboard
const Dashboard = React.lazy(() => import("pages/Dashboard"));

// Contact Us
// const ContactUs = React.lazy(() => import("pages/ContactUs/ContactUs"));
import ContactUs from "pages/ContactUs/ContactUs";

// Account
const Profile = React.lazy(() => import("pages/Profile"));
const WalletAddress = React.lazy(
  () => import("pages/PartnerModule/WalletAddress")
);

// Authentication
const Login = React.lazy(() => import("../pages/Authentication/Login"));
const Register = React.lazy(() => import("../pages/Authentication/Register"));
const PartnerRegister = React.lazy(() => import("../pages/Authentication/PartnerRegister"));
const ForgotPasswordPage = React.lazy(
  () => import("../pages/Authentication/ForgotPassword")
);
const ResetPasswordPage = React.lazy(
  () => import("../pages/Authentication/ResetPassword")
);

//! PARTNER
// Reports
const OpenTradeReports = React.lazy(
  () => import("pages/PartnerModule/Reports/OpenTradeReports/OpenTradeReports")
);
const TopClientsReport = React.lazy(
  () => import("pages/PartnerModule/Reports/TopClientsReport/TopClientsReport")
);
const ClientList = React.lazy(
  () => import("pages/PartnerModule/Reports/ClientList/ClientList")
);
const SubIBList = React.lazy(
  () => import("pages/PartnerModule/Reports/SubIBList/SubIBList")
);
const MoneyTransferReport = React.lazy(
  () =>
    import(
      "pages/PartnerModule/Reports/MoneyTransferReport/MoneyTransferReport"
    )
);
const ClosedTrades = React.lazy(
  () => import("pages/PartnerModule/Reports/ClosedTrades/ClosedTrades")
);
const Deals = React.lazy(
  () => import("pages/PartnerModule/Reports/Deals")
);
const EquityReport = React.lazy(
  () => import("pages/PartnerModule/Reports/EquityReport/EquityReport")
);

// Contracts
const Contract = React.lazy(
  () => import("pages/PartnerModule/Contract/Contract")
);
const ContractClientDetail = React.lazy(
  () =>
    import(
      "pages/PartnerModule/Contract/ContractClientDetail/ContractClientDetail"
    )
);
const ContractRatesDetail = React.lazy(
  () =>
    import(
      "pages/PartnerModule/Contract/ContractRatesDetail/ContractRatesDetail"
    )
);
const OldContractRatesDetail = React.lazy(
  () =>
    import(
      "pages/PartnerModule/Contract/ContractRatesDetail/OldContractRatesDetail"
    )
);
const CreateContract = React.lazy(
  () => import("pages/PartnerModule/Contract/CreateContract/CreateContract")
);

// Rebates
const RebatePNL = React.lazy(
  () => import("pages/PartnerModule/Rebate/RebatePNL")
);
const Rebate = React.lazy(() => import("pages/PartnerModule/Rebate/Rebate"));

// Payments
const PaymentHistory = React.lazy(
  () => import("pages/PartnerModule/Payment/PaymentHistory/PaymentHistory")
);

// Onboarding
const Onboarding = React.lazy(
  () => import("pages/PartnerModule/Onboarding/Onboarding")
);

//! SALES
// Sales Payments
const SalesPaymentHistory = React.lazy(
  () => import("pages/SalesModule/Payment/PaymentHistory/PaymentHistory")
);

// Sales Contracts
const SalesContractClientDetail = React.lazy(
  () => import("pages/SalesModule/Contract/ContractClientDetail")
);
// Sales Rebates
const SalesRebate = React.lazy(
  () => import("pages/SalesModule/Commission/Commission")
);
// Sales Reports
const SalesPartnerList = React.lazy(
  () => import("pages/SalesModule/Reports/PartnerList/PartnerList")
);
// const SalesNetworkList = React.lazy(
//   () => import("pages/SalesModule/Reports/NetworkList/NetworkList")
// );
const SalesList = React.lazy(
  () => import("pages/SalesModule/Reports/SalesList/SalesList")
);
const SalesClientList = React.lazy(
  () => import("pages/SalesModule/Reports/ClientList/ClientList")
);
const SalesOpenTradeReports = React.lazy(
  () => import("pages/SalesModule/Reports/OpenTradeReports/OpenTradeReports")
);
const SalesTopClientsReport = React.lazy(
  () => import("pages/SalesModule/Reports/TopClientsReport/TopClientsReport")
);
const SalesMoneyTransferReport = React.lazy(
  () =>
    import("pages/SalesModule/Reports/MoneyTransferReport/MoneyTransferReport")
);
const SalesClosedTrades = React.lazy(
  () => import("pages/SalesModule/Reports/ClosedTrades/ClosedTrades")
);
const SalesEquityReport = React.lazy(
  () => import("pages/SalesModule/Reports/EquityReport/EquityReport")
);

const authProtectedRoutes = [
  // this route should be at the end of all other routess
  // eslint-disable-next-line react/display-name
  //! COMMON
  { path: "/unauthorized", component: <Unauthorized /> },
  // Dashboard
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/index", component: <Dashboard /> },
  // Contact Us
  { path: "/contact-us", component: <ContactUs /> },
  // Account
  { path: "/profile", component: <Profile /> },
  {
    path: "/wallet-address",
    component: <WalletAddress />,
    allowedRoles: ["Partner"],
  },

  //! PARTNER
  // Reports
  {
    path: "/top-clients-report",
    component: <TopClientsReport />,
    allowedRoles: ["Partner"],
  },
  {
    path: "/client-list",
    component: <ClientList />,
    allowedRoles: ["Partner"],
  },
  { path: "/sub-ib-list", component: <SubIBList />, allowedRoles: ["Partner"] },
  {
    path: "/money-transfer-report",
    component: <MoneyTransferReport />,
    allowedRoles: ["Partner"],
  },
  {
    path: "/closed-trades",
    component: <ClosedTrades />,
    allowedRoles: ["Partner"],
  },
  {
    path: "/deals",
    component: <Deals />,
    allowedRoles: ["Partner"],
  },
  {
    path: "/open-position-report",
    component: <OpenTradeReports />,
    allowedRoles: ["Partner"],
  },
  {
    path: "/equity-report",
    component: <EquityReport />,
    allowedRoles: ["Partner"],
  },
  // Rebates
  { path: "/rebate", component: <Rebate />, allowedRoles: ["Partner"] },
  { path: "/rebate-pnl", component: <RebatePNL />, allowedRoles: ["Partner"] },
  // Contracts
  { path: "/contract", component: <Contract />, allowedRoles: ["Partner"] },
  {
    path: "/create-contract",
    component: <CreateContract />,
    allowedRoles: ["Partner"],
  },
  {
    path: "/contracts-client-detail/:id",
    component: <ContractClientDetail />,
    allowedRoles: ["Partner"],
  },
  {
    path: "/contracts-rates-detail/:id",
    component: <ContractRatesDetail />,
    allowedRoles: ["Partner"],
  },
  {
    path: "/spread-share-contracts-rates-detail/:id",
    component: <OldContractRatesDetail />,
    allowedRoles: ["Partner"],
  },
  // Payments
  {
    path: "/transaction-history",
    component: <PaymentHistory />,
    allowedRoles: ["Partner"],
  },
  // Onboarding
  { path: "/onboarding", component: <Onboarding />, allowedRoles: ["Partner"] },

  //! SALES
  // Sales Payments
  {
    path: "/sales-transaction-history",
    component: <SalesPaymentHistory />,
    allowedRoles: ["Seller"],
  },
  // Sales Contracts
  {
    path: "/sales-structure-details",
    component: <SalesContractClientDetail />,
    allowedRoles: ["Seller"],
  },
  // Sales Rebates / Commission
  {
    path: "/sales-commission",
    component: <SalesRebate />,
    allowedRoles: ["Seller"],
  },
  // Sales Reports
  // {
  //   path: "/sales-network-list",
  //   component: <SalesNetworkList />,
  //   allowedRoles: ["Seller"],
  // },
  {
    path: "/sales-partner-list",
    component: <SalesPartnerList />,
    allowedRoles: ["Seller"],
  },
  {
    path: "/sales-list",
    component: <SalesList />,
    allowedRoles: ["Seller"],
  },
  {
    path: "/sales-client-list",
    component: <SalesClientList />,
    allowedRoles: ["Seller"],
  },
  {
    path: "/sales-top-clients-report",
    component: <SalesTopClientsReport />,
    allowedRoles: ["Seller"],
  },
  {
    path: "/sales-money-transfer-report",
    component: <SalesMoneyTransferReport />,
    allowedRoles: ["Seller"],
  },
  {
    path: "/sales-closed-trades",
    component: <SalesClosedTrades />,
    allowedRoles: ["Seller"],
  },
  {
    path: "/sales-open-position-report",
    component: <SalesOpenTradeReports />,
    allowedRoles: ["Seller"],
  },
  {
    path: "/sales-equity-report",
    component: <SalesEquityReport />,
    allowedRoles: ["Seller"],
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/login/:language", component: <Login /> },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/open-partner-account",
    component: <PartnerRegister />,
  },
  {
    path: "/reset-password-email",
    component: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password-email/:language",
    component: <ForgotPasswordPage />,
  },
  { path: "/reset-password", component: <ResetPasswordPage /> },
];

export { authProtectedRoutes, publicRoutes };
